import React from 'react';
import { Twitter, Facebook, Instagram, Youtube, Linkedin, Send } from 'lucide-react';

const FooterCol = ({ title, links }) => (
  <div>
    <div className="text-white font-semibold mb-4">{title}</div>
    <ul className="space-y-2.5">
      {links.map(l => (
        <li key={l}><a href="#" className="text-sm text-gray-400 hover:text-[#00e676] transition-colors">{l}</a></li>
      ))}
    </ul>
  </div>
);

const Footer = () => (
  <footer className="bg-[#050807] border-t border-[#141f1b] pt-16 pb-8">
    <div className="max-w-[1400px] mx-auto px-6">
      <div className="grid md:grid-cols-2 lg:grid-cols-6 gap-10 mb-12">
        <div className="lg:col-span-2">
          <div className="flex items-center gap-2 mb-4">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
              <path d="M6 22 L18 6 L26 12 L14 28 Z" fill="#00e676"/>
              <path d="M14 28 L22 20" stroke="#062516" strokeWidth="2"/>
            </svg>
            <span className="text-xl font-extrabold text-white whitespace-nowrap">NEXUS FX <span className="text-[#00e676]">PRO</span></span>
          </div>
          <p className="text-sm text-gray-400 leading-relaxed max-w-sm">
            Institutional-grade Forex, CFD, and multi-asset trading. Serving 27,000+ traders across 150+ countries with deep liquidity, tight spreads, and 24/7 human support.
          </p>
          <div className="mt-6 flex items-center gap-3">
            {[
              { Icon: Twitter, name: 'twitter' },
              { Icon: Facebook, name: 'facebook' },
              { Icon: Instagram, name: 'instagram' },
              { Icon: Youtube, name: 'youtube' },
              { Icon: Linkedin, name: 'linkedin' },
              { Icon: Send, name: 'telegram' }
            ].map(({ Icon, name }) => (
              <a key={name} href="#" className="w-9 h-9 rounded-lg border border-[#1a2823] flex items-center justify-center text-gray-400 hover:text-[#00e676] hover:border-[#00e676] transition">
                <Icon size={15}/>
              </a>
            ))}
          </div>
        </div>
        <FooterCol title="Trade" links={['Forex', 'Commodities', 'Indices', 'Stocks (CFDs)', 'Cryptocurrencies', 'ETFs']}/>
        <FooterCol title="Platforms" links={['cTrader', 'WebTrader', 'Mobile App', 'TradingView', 'Marketplace', 'VPS']}/>
        <FooterCol title="Company" links={['About Us', 'Regulation', 'Careers', 'Contact', 'Press', 'Legal']}/>
        <FooterCol title="Learn" links={['Academy', 'Webinars', 'Blog', 'Analysis', 'FAQ', 'Glossary']}/>
      </div>
      <div className="pt-8 border-t border-[#141f1b] flex flex-col md:flex-row items-center justify-between gap-4">
        <p className="text-xs text-gray-500">© {new Date().getFullYear()} NEXUS FX PRO. All rights reserved. Trading involves risk.</p>
        <div className="flex items-center gap-6 text-xs text-gray-500">
          <a href="#" className="hover:text-[#00e676]">Privacy</a>
          <a href="#" className="hover:text-[#00e676]">Terms</a>
          <a href="#" className="hover:text-[#00e676]">Risk Disclosure</a>
          <a href="#" className="hover:text-[#00e676]">Cookies</a>
        </div>
      </div>
      <div className="mt-8 p-4 rounded-lg bg-[#0a1210] border border-[#141f1b]">
        <p className="text-[11px] text-gray-500 leading-relaxed">
          <span className="text-gray-400 font-semibold">Risk Warning:</span> Trading Forex and CFDs carries a high level of risk and may result in the loss of all your invested capital. Leverage products may not be suitable for all investors. Please ensure you fully understand the risks involved. This is a demo clone site built for educational purposes.
        </p>
      </div>
    </div>
  </footer>
);

export default Footer;
